// extracted by mini-css-extract-plugin
export default {"descr":"styles_descr__JzIQA","hideText":"styles_hideText__ADJ5D"};